var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 0.25C5.79223 0.25 0.75293 4.78586 0.75293 10.375C0.75293 19.375 12.0029 31.75 12.0029 31.75C12.0029 31.75 23.2529 19.375 23.2529 10.375C23.2529 4.78586 18.2136 0.25 12.0029 0.25ZM12.0029 16C11.1129 16 10.2429 15.7361 9.50286 15.2416C8.76284 14.7471 8.18607 14.0443 7.84547 13.2221C7.50488 12.3998 7.41576 11.495 7.5894 10.6221C7.76303 9.74918 8.19161 8.94736 8.82095 8.31802C9.45028 7.68868 10.2521 7.2601 11.125 7.08647C11.9979 6.91283 12.9027 7.00195 13.725 7.34254C14.5473 7.68314 15.2501 8.25991 15.7445 8.99993C16.239 9.73996 16.5029 10.61 16.5029 11.5C16.5016 12.6931 16.0271 13.8369 15.1835 14.6805C14.3398 15.5242 13.196 15.9987 12.0029 16Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.6750f11deadb6a1c8378038bbd096c9a.svg";
export { ForwardRef as ReactComponent };